export default import.meta.ROLLUP_FILE_URL_DQ28s_VH;